<template>
  <div>
    <cadastro-base
      :salvar="salvar"
      :cancelar-cadastro="cancelar"
    >
      <template slot="conteudo">
        <b-row>
          <b-form-group
            label="Razão Social"
            class="col-md-6"
          >
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="Razão Social"
            >
              <b-form-input
                v-model="form.razaoSocial"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-col cols="6">
            <b-form-group label="CNPJ">
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="CNPJ"
              >
                <masked-input
                  ref="cnpj"
                  v-model="form.cnpj"
                  :mask="construirMascara"
                  class="form-control"
                  placeholder=""
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-form-group
            label="E-mail"
            class="col-md-8"
          >
            <validation-provider
              #default="{ errors }"
              rules="required|email"
              name="E-mail"
            >
              <b-form-input v-model="form.email" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group
            label="Dia de Vencimento da Integração OMIE"
            class="col-4"
          >
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="Dia de Vencimento da Integração OMIE"
            >
              <b-select v-model="form.diaFaturamentoOMIE">
                <option
                  v-for="$index in 31"
                  :key="$index"
                  :value="$index"
                >
                  {{ $index }}
                </option>
              </b-select>
              <small
                v-if="errors[0]"
                class="text-danger"
              >Campo obrigatório</small>
            </validation-provider>
          </b-form-group>
        </b-row>

        <b-row>
          <b-col cols="12">
            <upload-e-visualizacao
              ref="upload"
              :value="form.logo"
            />
          </b-col>
        </b-row>
      </template>
    </cadastro-base>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import {
  required,
} from '@validations'
import api from '@/app-modulo/comuns/proprietario/shared/services/api'
import CadastroBase from '@/shared/components/cadastro-base/CadastroBase.vue'

export default {
  name: 'Proprietario',
  components: {
    CadastroBase,
    ValidationProvider,
    UploadEVisualizacao: () => import('@/shared/components/upload-e-visualizacao/UploadEVisualizacao.vue'),
  },
  data() {
    return {
      required,
      form: {
        id: null,
        cnpj: null,
        razaoSocial: null,
        email: null,
        logo: null,
        diaFaturamentoOMIE: null,
      },
      immutableForm: {},
      maskApplied: 0,
      isAlteracao: false,
    }
  },
  created() {
    this.carregar()
  },
  methods: {
    carregar() {
      api.getProprietario()
        .then(payload => {
          this.form = payload.data
          this.form.diaFaturamentoOMIE = this.form.diaFaturamentoOMIE === 0 ? null : this.form.diaFaturamentoOMIE
          if (!this.form) {
            this.form = {}
          } else {
            this.isAlteracao = true
          }
        })
    },
    salvar() {
      return new Promise((resolve, reject) => {
        const form = { ...this.form }
        form.logo = null

        const formData = this.$refs.upload.getFormDataBody(form)
        api.updateProprietario(formData)
          .then(payload => {
            const acao = this.isAlteracao ? 'alterado' : 'cadastrado'
            resolve(`Proprietário ${acao} com sucesso`)

            this.form.id = payload.data
            this.isAlteracao = !this.isAlteracao ? true : this.isAlteracao
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    cancelar() {
    },
    construirMascara() {
      return [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]
    },
  },
}
</script>
